import moment from 'moment';
import uuid from 'uuid';
import React, { useEffect, useState } from 'react';
import { ActivityIndicator, View } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import Colors from '../../../constants/Colorsv2';
import { social_bulkGetArticles, social_logImpression } from '../../../store/actionsv1/social';
import { ArticleProps } from '../../../store/types/soc_svc';
import InstaArticle from './InstaArticle';
import NewsArticle from './NewsArticle';
type ArticleWidgetProps = {
    article_id:string,
    viewer_id?:string,
    width:number
}

const ArticleWidget = ({ article_id, width, viewer_id }:ArticleWidgetProps) => {
    const [ loading, setLoading ] = useState(false);

    const dispatch = useDispatch();
    const articles_list:{updated:number, articles:ArticleProps[]} = useSelector((state:any) => state.social.articles_list, (left, right) => left.updated == right.updated)
    const article = articles_list.articles.find(a => a.article_id == article_id);
    
    useEffect(() => {
        if(!article_id){ return }
        getDataFromServer(article_id)
    },[article_id])

    const getDataFromServer = async(article_id:string) => {
        if(article){ return }
        setLoading(true)
        await dispatch(social_bulkGetArticles([article_id]))
        setLoading(false)
    }

    const handleSelectArticle = async(article:ArticleProps) => {
        window.open(article.url, '_blank')
    }

    return (
        <View>
            {loading || !article ?
            <ActivityIndicator size='large' color={Colors.brand.midnight}/>
            :
            <View nativeID='details'>
                {article.source == 'instagram' ?
                <InstaArticle
                    article={article}
                    width={width}
                    onSelect={(article) => handleSelectArticle(article)}
                />
                :
                <NewsArticle
                    article={article}
                    width={width}
                    onSelect={(article) => handleSelectArticle(article)}
                />
                }
            </View>
            }
        </View>
    )
}


export default ArticleWidget